import { render, staticRenderFns } from "./NumeroHC.vue?vue&type=template&id=28712d90"
import script from "./NumeroHC.vue?vue&type=script&lang=js"
export * from "./NumeroHC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports